import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useValidateResetTokenQuery, useResetPasswordMutation } from 'src/services/rtk_api/auth/authApi';
import { addToast } from '@heroui/react';

import ResetPassword from './components/reset_password/ResetPassword';
import ResetPasswordRequestForm from './components/reset_password/ResetPasswordRequestForm';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token');
  const [resetPassword, { isLoading: isResetting }] = useResetPasswordMutation();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const {
    isFetching,
    isError,
    isSuccess,
  } = useValidateResetTokenQuery(token, {
    skip: !token,
  });

  useEffect(() => {
    if (token && isError) {
      addToast({
        title: 'Invalid reset token, try requesting the reset again.',
        severity: "danger",
        color: "danger"
      });
      navigate('/reset-password', { replace: true });
    }
  }, [token, isError, navigate]);

  const handlePasswordReset = async (password, token) => {
    try {
      await resetPassword({
        token,
        password,
        password_confirmation: password,
      }).unwrap();

      setIsRedirecting(true);

      let seconds = 3;

      const CountdownToast = () => {
        const [count, setCount] = useState(seconds);

        useEffect(() => {
          const interval = setInterval(() => {
            setCount((prev) => {
              if (prev <= 1) {
                clearInterval(interval);
                navigate('/login', { replace: true });
              }
              return prev - 1;
            });
          }, 1000);

          return () => clearInterval(interval);
        }, []);

        return <span>Password updated! Redirecting to login in {count}...</span>;
      };

      addToast({
        title: <CountdownToast />,
        severity: "success",
        color: "success",
        timeout: null,
        hideCloseButton: true
      });
    } catch (error) {
      console.error('Reset password failed:', error);
      addToast({
        title: 'There was an error resetting your password.',
        severity: "danger",
        color: "danger"
      });
    }
  };

  if (token && isFetching) {
    return <p className="text-center mt-10">Validating reset link...</p>;
  }

  if (token && isSuccess) {
    return (
      <div className="max-w-[500px] w-full mx-auto mt-10 px-4">
        <ResetPassword
          loading={isResetting}
          isButtonDisabled={isRedirecting}
          onSubmit={handlePasswordReset}
          token={token}
        />
      </div>
    );
  }

  return <ResetPasswordRequestForm />;
};

export default ResetPasswordPage;